import dayjs from 'dayjs'
import ApiService from '../../common/ApiCalls'

export const nameSeparator = name => {
  const nameArray = name.split(' ')
  const lastName = nameArray.slice(-1)[0]
  const firstName = name.replace(` ${lastName}`, '')
  return { firstName, lastName }
}

export const today = dayjs().format('MMM D, YYYY')

export const recordFormatter = recordArray => {
  let formattedArray = []
  if (recordArray) {
    for (let i = 0; i < recordArray.length; i++) {
      const {
        record_name,
        name,
        document,
        effective_date,
        expiry_date,
        type_name,
        record_type
      } = recordArray[i]
      formattedArray.push({
        recordType: type_name || record_type || '',
        recordName: record_name || name || '',
        recordLink: document && document.url ? document.url : '',
        expiryDate: expiry_date,
        effectiveDate: effective_date
      })
    }
  }

  if (formattedArray.length === 0) {
    formattedArray = [
      {
        recordType: '',
        recordName: '',
        recordLink: '',
        expiryDate: null,
        effectiveDate: null
      }
    ]
  }
  return formattedArray
}

export const serviceListFormatter = serviceList => {
  const formattedServiceList = []
  Object.keys(serviceList).forEach(key => {
    for (let i = 0; i < serviceList[key].length; i++) {
      formattedServiceList.push(serviceList[key][i].service_id)
    }
  })
  return formattedServiceList
}

export const newServiceListFormatter = serviceList => {
  const formattedServiceList = []
  Object.keys(serviceList).forEach(key => {
    for (let i = 0; i < serviceList[key].length; i++) {
      formattedServiceList.push(serviceList[key][i].serviceName)
    }
  })
  return formattedServiceList
}

export const serviceSetFormatter = serviceSet => {
  const formattedServiceList = []
  Object.keys(serviceSet).forEach(key => {
    for (let i = 0; i < serviceSet[key].length; i++) {
      const serviceObj = { ...serviceSet[key][i] }
      serviceObj.attachment = JSON.stringify({
        [serviceObj.attachmentTitle]: serviceObj.attachmentUrl
      })
      formattedServiceList.push(serviceObj)
    }
  })
  return formattedServiceList
}

export const formatServiceAttachment = serviceSet => {
  const formattedServiceObj = { ...serviceSet }
  Object.keys(formattedServiceObj).forEach(key => {
    for (let i = 0; i < serviceSet[key].length; i++) {
      const serviceObj = serviceSet[key][i]
      serviceObj.attachment = JSON.stringify({
        [serviceObj.attachmentTitle]: serviceObj.attachmentUrl
      })
    }
  })
  return formattedServiceObj
}

export const contactListFormatter = contactList => {
  const formattedContactList = {
    existingContacts: [],
    newContacts: []
  }
  Object.keys(contactList).forEach(key => {
    for (let i = 0; i < contactList[key].length; i++) {
      if (contactList[key][i].contactId) {
        formattedContactList.existingContacts.push(
          contactList[key][i].contactId
        )
      } else {
        formattedContactList.newContacts.push({
          ...contactList[key][i],
          organizationId: contactList[key][i].organization
            ? contactList[key][i].organization.account_id
            : ''
        })
      }
    }
  })
  return formattedContactList
}

export const recordUrlFormatter = url => {
  return { url: url }
}

export const clientWithoutEndCustomerRemover = clientList => {
  return clientList.filter(client => {
    return client.end_customer_id
  })
}

export const removeSpace = string => {
  return string.replace(/ /g, '')
}

export const spaceRemover = string => {
  return string.replace(/ /g, '')
}

export const areAllObjectValuesEmpty = object => {
  for (const i in object) {
    if (object[i].length > 0) return false
  }
  return true
}

export const isObjectEmpty = object => {
  return Object.keys(object).length === 0
}

export const formatNewServiceSet = (newServiceSet, selectedServiceObj) => {
  const formattedNewServiceSet = { ...newServiceSet }
  Object.keys(selectedServiceObj).forEach(key => {
    for (let i = 0; i < selectedServiceObj[key].length; i++) {
      const targetedService = formattedNewServiceSet[key].find(
        service =>
          service.serviceName === selectedServiceObj[key][i].serviceName
      )
      targetedService.selected = true
    }
  })
  return formattedNewServiceSet
}

export const formatPhoneNumber = phoneNumberStr => {
  return phoneNumberStr.replace(/[^0-9]/g, '')
}

export const formatInspectionDate = date => {
  return dayjs(date.toDate).format('MMM DD, YYYY')
}

export const formatClientData = data => {
  return {
    ...data,
    accountPhoneNumber: formatPhoneNumber(data.accountPhoneNumber)
  }
}

export const formatExistingServiceSearch = searchResult => {
  const formattedSearchResult = [...searchResult]
  for (let i = 0; i < formattedSearchResult.length; i++) {
    formattedSearchResult[i].serviceName = formattedSearchResult[i].name
  }
  return formattedSearchResult
}

export const formatNewContactsWithOrganization = (
  newContacts,
  organizationId,
  organizationName
) => {
  const formattedNewContacts = newContacts ? [...newContacts] : []
  for (let i = 0; i < formattedNewContacts.length; i++) {
    const isContractor =
      formattedNewContacts[i].contactType === 'Bee-Clean Contractor'
    formattedNewContacts[i] = {
      ...formattedNewContacts[i],
      organizationId: isContractor ? organizationId : '',
      organizationName: isContractor ? organizationName : ''
    }
  }
  return formattedNewContacts
}

export const serviceFormInProgress = serviceData => {
  const { serviceName, serviceDescription, attachmentTitle, attachmentUrl } =
    serviceData
  return serviceName || serviceDescription || attachmentTitle || attachmentUrl
}

export const leaveServiceFormHandler = () => {
  window.confirm(
    'Service creation is in progress. Add/Update the service you are working on.'
  )
}

export const peopleFormInProgress = contactData => {
  const {
    firstName,
    lastName,
    jobTitle,
    phoneNumber,
    email,
    description,
    records,
    contactId
  } = contactData
  const { recordType, recordName, recordLink, expiryDate, effectiveDate } =
    records[0]

  return (
    !contactId &&
    (firstName ||
      lastName ||
      jobTitle ||
      phoneNumber ||
      email ||
      description ||
      recordType ||
      recordName ||
      recordLink ||
      expiryDate ||
      effectiveDate)
  )
}

export const leaveContactFormHandler = () => {
  window.confirm(
    'Contact creation is in progress. Add/Update the contact you are working on.'
  )
}

export const checkAddressExistence = async addressData => {
  const {
    addressLine1,
    addressLine2,
    city,
    province,
    country,
    postalCode,
    unit
  } = addressData
  const data = {
    address: {
      address1: addressLine1,
      address2: addressLine2,
      city: city,
      province: province,
      country: country,
      postalCode: postalCode,
      unit: unit
    }
  }

  return await ApiService().addressExistenceCheck(data)
}

export const translateImportType = importType => {
  switch (importType) {
    case 'esel':
      return 'New Service'
    case 'nlnc':
      return 'New Client'
    case 'nlec':
      return 'New Location'
    case 'ncel':
      return 'New Contact'
    case 'nc':
      return 'Add Comment'
    case 'ndd':
      return 'Add Dashboard Metrics'
    case 'ec':
      return 'Edit Comment'
    case 'edd':
      return 'Edit Dashboard Metrics'
    case 'dc':
      return 'Delete Comment'
    case 'ddd':
      return 'Delete Dashboard Metrics'
    case 'nf':
      return 'Add Feedback'
    case 'ef':
      return 'Edit Feedback'
    case 'df':
      return 'Delete Feedback'
    default:
      return ''
  }
}

export const translateImportStatus = status => {
  switch (status) {
    case 'pending':
      return 'Pending Approval'
    case 'rejected':
      return 'Rejected'
    default:
      return status
  }
}

export const approveDataImportRecord = recordId => {
  const data = { dataId: recordId }
  return ApiService().approvePendingData(data)
}

export const rejectDataImportRecord = (recordId, reason, initiatorEmail) => {
  const data = {
    dataId: recordId,
    rejectMessage: reason,
    initiatorEmail: initiatorEmail
  }
  return ApiService().rejectPendingData(data)
}

export const extractValuesFromObjectArray = (objectArray, key) => {
  const extractValuesArray = []
  for (let i = 0; i < objectArray.length; i++) {
    extractValuesArray.push(objectArray[i][key])
  }
  return extractValuesArray
}

export const extractUniqueValuesFromArray = array => {
  return array.filter((v, i, a) => a.indexOf(v) === i)
}

export const selectedCounter = options => {
  if (!options) return 0
  let counter = 0
  for (let i = 0; i < options.length; i++) {
    options[i].selected && counter++
  }
  return counter
}

export const groupFeatureByCategory = selectedFeatureSets => {
  const copy = {
    Locations: [],
    People: [],
    Service: [],
    Account: [],
    Admin: []
  }

  for (let i = 0; i < selectedFeatureSets.length; i++) {
    if (selectedFeatureSets[i].name.includes('Location')) {
      copy.Locations.push(selectedFeatureSets[i])
    } else if (selectedFeatureSets[i].name.includes('People')) {
      copy.People.push(selectedFeatureSets[i])
    } else if (selectedFeatureSets[i].name.includes('Service')) {
      copy.Service.push(selectedFeatureSets[i])
    } else if (selectedFeatureSets[i].name.includes('Account')) {
      copy.Account.push(selectedFeatureSets[i])
    } else if (
      selectedFeatureSets[i].name !== 'Map Search' &&
      selectedFeatureSets[i].name !== 'Menu Access'
    ) {
      copy.Admin.push(selectedFeatureSets[i])
    }
  }

  return copy
}

export const sortAlphabetically = (array, targetKey) => {
  if (targetKey) {
    array.sort(function (a, b) {
      if (a[targetKey] < b[targetKey]) return -1
      if (a[targetKey] > b[targetKey]) return 1
      return 0
    })
  } else {
    array.sort(function (a, b) {
      if (a < b) return -1
      if (a > b) return 1
      return 0
    })
  }
}

export const uncheckItem = (targetList, id, idKey) => {
  const copy = [...targetList]
  const target = copy.find(el => el[idKey] === id)
  target.selected = false
  return copy
}

export const removeItemFromArray = (targetList, id, idKey) => {
  const copy = [...targetList]
  return copy.filter(el => el[idKey] !== id)
}

export const checkSelected = list => {
  let flag = false
  for (let i = 0; i < list.length; i++) {
    if (list[i].selected) {
      flag = true
    }
  }
  return flag
}

export const splitStrings = string => {
  return string.split(',')
}

export const extractSelectedItemsFromArray = (array, idKey) => {
  const extractedList = []
  array.forEach(item => {
    if (item.selected) extractedList.push(item[idKey])
  })
  return extractedList
}

export const extractItemsFromArray = (array, idKey) => {
  const extractedList = []
  array.forEach(item => {
    extractedList.push(item[idKey])
  })
  return extractedList
}

export const createFeaturesCheckList = async () => {
  return await ApiService()
    .getAllFeaturesList()
    .then(res => {
      const featureList = [...res.data.data]
      sortAlphabetically(featureList, 'name')
      for (let i = 0; i < featureList.length; i++) {
        featureList[i].selected = false
      }
      const groupedFeatures = groupFeatureByCategory(featureList)

      return [].concat(
        { name: 'Locations' },
        groupedFeatures.Locations,
        { name: 'People' },
        groupedFeatures.People,
        { name: 'Service' },
        groupedFeatures.Service,
        { name: 'Account' },
        groupedFeatures.Account,
        { name: 'Admin' },
        groupedFeatures.Admin
      )
    })
}

export const formatTerritoryCheckList = list => {
  const territoryList = list.filter(item => {
    return item.resource_type_id === '300d1740-7b7c-4aaf-a965-e4a096bd3f99'
  })
  const provinceList = territoryList.filter(item => {
    return item.name.length === 2
  })
  sortAlphabetically(provinceList, 'name')
  const canada = territoryList.find(item => {
    return item.name === 'Canada'
  })

  const checkListBase = [
    { name: 'Country' },
    { ...canada, selected: false },
    { name: 'Province' }
  ]
  provinceList.forEach(item => {
    item.selected = false
  })
  return checkListBase.concat(provinceList)
}

export const createTerritoryCheckList = async () => {
  return await ApiService()
    .getAllResourcesList()
    .then(res => {
      const allResources = res.data.data
      return formatTerritoryCheckList(allResources)
    })
}

export const formatBusinessCheckList = list => {
  const businessList = list.filter(item => {
    return item.resource_type_id === '9911ab73-362c-4565-92ca-13d996d92ed1'
  })
  sortAlphabetically(businessList, 'name')
  businessList.forEach(item => {
    item.selected = false
  })
  return businessList
}

export const createBusinessCheckList = async () => {
  return await ApiService()
    .getAllResourcesList()
    .then(res => {
      const allResourcesList = res.data.data
      return formatBusinessCheckList(allResourcesList)
    })
}

export const getFeatureDetailsByNames = async featureNameArray => {
  return await createFeaturesCheckList().then(allFeaturesList => {
    allFeaturesList.forEach(featureData => {
      const selectedFeatureIndex = featureNameArray.findIndex(feature => {
        return featureData.name === feature
      })

      if (selectedFeatureIndex !== -1) {
        featureData.selected = true
      } else if (featureData.feature_id) {
        featureData.selected = false
      }
    })

    return allFeaturesList
  })
}

export const separateResourcesByCategory = resourcesArray => {
  const business = []
  const territory = []
  resourcesArray.forEach(resource => {
    const [resourceName, resourceType] = resource.split(':')
    if (resourceType === 'business') {
      business.push(resourceName)
    } else {
      territory.push(resourceName)
    }
  })

  return { business, territory }
}

export const selectAllProvinces = territoryCheckList => {
  const province = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NS',
    'NT',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT'
  ]
  territoryCheckList.forEach(territory => {
    if (province.includes(territory.name)) territory.selected = true
  })
}

export const isAllProvincesAreChecked = territoryCheckList => {
  for (let i = 3; i < territoryCheckList.length; i++) {
    if (!territoryCheckList[i].selected) {
      return false
    }
  }
  return true
}

export const territoriesHandler = provincesCheckList => {
  // Canada is selected = All Provinces are selected
  if (provincesCheckList[1].selected) {
    selectAllProvinces(provincesCheckList)
  }

  // All Provinces are selected = Canada is selected
  provincesCheckList[1].selected = isAllProvincesAreChecked(provincesCheckList)
}

export const populateTerritoriesDataForEdit = async territoriesData => {
  const { territory } = separateResourcesByCategory(territoriesData)
  const territoryCheckList = await createTerritoryCheckList()

  territoryCheckList.forEach(territoryCheckbox => {
    const index = territory.findIndex(territoryName => {
      return territoryName === territoryCheckbox.name
    })

    if (index !== -1) {
      territoryCheckbox.selected = true
    } else if (territoryCheckbox.resource_id) {
      territoryCheckbox.selected = false
    }
  })

  return territoryCheckList
}

export const populateBusinessesDataForEdit = async territoriesData => {
  const { business } = separateResourcesByCategory(territoriesData)
  const businessCheckList = await createBusinessCheckList()
  const selectedBusinessesList = []

  businessCheckList.forEach(businessCheckbox => {
    const index = business.findIndex(territoryName => {
      return territoryName === businessCheckbox.name
    })

    if (index !== -1) {
      selectedBusinessesList.push(businessCheckbox)
    }
  })

  return selectedBusinessesList
}

export const populateAssignedUserForEdit = async assignedUserData => {
  const assignedUserList = []

  for (let i = 0; i < assignedUserData.length; i++) {
    const { userName, userEmail } = assignedUserData[i]
    const data = { searchInput: userName }
    const userArrayWithSameName = await ApiService().searchApprover(data)
    const selectedUser = userArrayWithSameName.find(userArray => {
      return userArray.email === userEmail
    })
    assignedUserList.push(selectedUser)
  }

  return assignedUserList
}

export const populateOwnerForEdit = async ownerName => {
  const data = { searchInput: ownerName }
  const userArrayWithSameName = await ApiService().searchApprover(data)
  return userArrayWithSameName ? userArrayWithSameName[0] : null
}

export const deepCopyObjectArray = objectArray => {
  const a = JSON.stringify(objectArray)
  return JSON.parse(a)
}

export const deepCopyObject = object => {
  const a = JSON.stringify(object)
  return JSON.parse(a)
}

export const getRequiredExportId = (selection, ...keys) => {
  const id = keys
    .map(key => selection?.[key])
    .find(value => typeof value === 'string' && value.trim().length > 0)

  if (!id) {
    throw new Error('The selected export record does not have a valid identifier')
  }

  return id
}

export function download (csv, fileName) {
  if (typeof csv !== 'string' || csv.trim().length === 0) {
    throw new Error('CSV data is empty or invalid')
  }

  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  try {
    a.click()
  } finally {
    a.remove()
    URL.revokeObjectURL(url)
  }
}

const nameDataExportCsvFile = dataType => {
  const today = dayjs().format('MM_DD_YYYY')
  return `${dataType}_data_${today}.csv`
}

export const downloadCsvData = async (
  fetchFunction,
  setIsErrorSnackbarOpen,
  dataType
) => {
  try {
    const fileName = nameDataExportCsvFile(dataType)
    const csvString = await fetchFunction()
    download(csvString, fileName)
    setIsErrorSnackbarOpen(false)
    return true
  } catch (error) {
    console.error('There was an error in fetching CSV data', error)
    setIsErrorSnackbarOpen(true)
    return false
  }
}

export const downloadCsvTemplate = async (
  csvString,
  setIsErrorSnackbarOpen,
  dataType
) => {
  try {
    const fileName = nameDataExportCsvFile(dataType)
    download(csvString, fileName)
    setIsErrorSnackbarOpen(false)
    return true
  } catch (error) {
    console.error('There was an error in fetching CSV template', error)
    setIsErrorSnackbarOpen(true)
    return false
  }
}

export const hasOnlyNumbers = input => {
  if (input) {
    const numbers = /^[0-9]+$/
    return input.toString().match(numbers)
  }
  return false
}

export const hasOnlyKeys = object => {
  const keyList = Object.keys(object)
  for (let i = 0; i < keyList.length; i++) {
    if (
      object[keyList[i]] === null ||
      object[keyList[i]] === '' ||
      Object.keys(object[keyList[i]])
    )
      return true
  }

  return false
}

export const isEmptyObj = obj => {
  return Object.keys(obj).length === 0
}

export const searchTimeOut = (searchText, searchFunction) => {
  let timeOut
  if (searchText.trim().length >= 2) {
    timeOut = setTimeout(() => {
      searchFunction()
    }, 550)
  }

  return () => {
    clearTimeout(timeOut)
  }
}

export const moveElementInArrayAt = (array, index, at) => {
  if (index === at || index > array.length - 1 || at > array.length - 1) {
    return array
  }

  const value = array[index]
  const tail = array.slice(index + 1)

  array.splice(index)

  Array.prototype.push.apply(array, tail)

  array.splice(at, 0, value)

  return array
}
